// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xt_a bhs_uj bhs_ua bhs_vx bhs_qk bhs_sl bhs_qb"};